module.exports = __webpack_public_path__ + "static/media/4.224ff791.png";